import { useEffect, useState } from 'react';
import { isFormValid } from './validation/isFormValid';
import { urls } from './api/urls';
import Inputs from './components/Inputs';
import GridProvider from './components/GridProvider';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import MuiDialog from '../../UI/MuiDialog/MuiDialog';
import useHttp from '../../../hooks/use-http';

const INITIAL_VALUES = {
  id: 0,
  naziv: '',
  metadata: null,
  vrednost: '',
};

const RabatneGrupe = ({ save, handleSave, novi, handleNovi }) => {
  const { sendRequest, getData, data, isLoading } = useHttp('');
  const [formValues, setFormValues] = useState(INITIAL_VALUES);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const { t, i18n } = useTranslation();

  const vratiRabatneGrupe = () => {
    sendRequest({ url: urls.VARATI_RABATNEGRUPE });
  };
  useEffect(() => {
    vratiRabatneGrupe();
  }, []);
  const handleSaveData = async () => {
    if (isFormValid(formValues)) {
      return;
    }
    const config = {
      method: 'POST',
      url:
        formValues.id !== 0
          ? urls.UPDATE_RABATNEGRUPE
          : urls.INSERT_RABATNEGRUPE,
      data: {
        ...formValues,
        vrednost: +formValues.vrednost,
        idKorProm: +localStorage.idKorisnika,
      },
    };
    const result = await getData(config);
    if (result.id > 0) {
      vratiRabatneGrupe();
      setFormValues(INITIAL_VALUES);
      toast.success(
        formValues.id === 0
          ? 'Uspešan unos podatak'
          : 'Uspešna izmena podataka',
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };

  useEffect(() => {
    if (novi) {
      handleNovi(false);
      setFormValues(INITIAL_VALUES);
    }
  }, [novi]);

  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);
  const handleOpenDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setFormValues({ ...INITIAL_VALUES, id: id });
  };
  const handleEditData = async (item) => {
    setFormValues(item);
    setOpenPopUp(true);
  };
  const handleDelete = async () => {
    const config = {
      method: 'POST',
      url: urls.DELETE_RABATNEGRUPE,
      data: {
        id: formValues.id,
      },
    };
    const result = await getData(config);
    if (result > 0) {
      vratiRabatneGrupe();
      setOpenDeleteDialog(false);
      return;
    }
    toast.error(handleErrorMessage(result));
  };

  return (
    <div>
      <Inputs formValues={formValues} setFormValues={setFormValues} />
      <GridProvider
        data={data}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        handleEditData={handleEditData}
        loading={isLoading}
      />
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        deniedText="ZATVORI"
      />
    </div>
  );
};

export default RabatneGrupe;
